import type * as React from 'react';
import { Button } from '@doda/io-react/common';

/**
 * SeeJobDetailsコンポーネントのプロパティ
 */
interface SeeJobDetailsProps {
  /** ボタンのリンク先URL */
  href: string;
  /** ナビゲーション時のクリックハンドラー（任意）*/
  onNavigate?: React.MouseEventHandler<HTMLAnchorElement>;
}

/**
 * 「求人詳細を見る」ボタン
 * @param {SeeJobDetailsProps} props - コンポーネントのプロパティ
 * @returns {JSX.Element} SeeJobDetailsのJSX要素
 */
export const SeeJobDetails = ({ href, onNavigate }: SeeJobDetailsProps) => {
  return (
    <Button
      as="a"
      variant="green"
      size="M"
      href={href}
      target="_blank"
      rel="noopener"
      onClick={onNavigate}
    >
      求人詳細を見る
    </Button>
  );
};
